import { get, post } from 'utils/api';

export const getAdminAccessUsers = (data) => {
  return get(`/users/getAdminAccessUsers`, data);
};

export const createAdminAccess = (data) => {
  return post(`/users/createAdminaccess`, data);
};

export const adminAccess = {
  getAdminAccessUsers,
  createAdminAccess,
};
